import React from 'react';
import IconDashboard from '../icons/iconDashboard';
import IconCalendarClock from '../icons/iconCalendarClock';
import IconFolder from '../icons/iconFolder';
import IconAnalytics from '../icons/iconAnalytics';
import IconBrands from '../icons/iconBrands';
import IconUsersGear from '../icons/iconUsersGear';
import IconMentions from '@material-ui/icons/SmsRounded';

const menu = [
  {

    name: 'Dashboard',
    label: 'Dashboard',
    renderIcon: () => (
      <IconDashboard />
    ),
    link: '/',
    isDisabled: false,
    userRole: ["1", "2"],
  },
  {
    name: 'publish',
    label: 'Publish',
    renderIcon: () => (
      <IconCalendarClock />
    ),
    link: '/calendar',
    isDisabled: false,
    userRole: ["1", "2"],
    children: [
      {
        name: 'compose',
        label: 'Compose',
        link: '/new-post'
      },
      {
        name: 'scheduler',
        label: 'Scheduler',
        link: '/calendar'
      },
      {
        name: 'drafts',
        label: 'Drafts',
        link: '/drafts'
      }
    ]
  },
  {
    name: 'contentCuration',
    label: 'File Manager',
    renderIcon: () => (
      <IconFolder />
    ),
    link: '/contentCuration',
    isDisabled: false,
    userRole: ["1", "2"],
  },
  {
    name: 'analyltics',
    label: 'Analytics',
    renderIcon: () => (
      <IconAnalytics />
    ),
    link: '/analytics',
    isDisabled: false,
    userRole: ["1", "2"],
  },
  {
    name: 'socialInbox',
    label: 'Social Inbox',
    renderIcon: (isActive) => (
      <IconMentions htmlColor={isActive ? 'rgba(0, 0, 0, 1)' : 'rgba(29, 56, 83, 1)'} />
    ),
    link: '/socialInbox',
    isDisabled: false,
    userRole: ["1", "2"],
    comingSoon: true,
  },
  {
    name: 'brandsProfile',
    label: 'Brands & Profiles',
    renderIcon: () => (
      <IconBrands />
    ),
    link: '/brands',
    isDisabled: false,
    userRole: ["1", "2"],
  },
  {
    name: 'team',
    label: 'Team Management',
    renderIcon: () => (
      <IconUsersGear />
    ),
    link: '/team',
    isDisabled: false,
    userRole: ["1"],
  },
  {
    name: 'logs',
    label: 'Logs',
    renderIcon: () => (
      <IconFolder />
    ),
    link: '/logs',
    isDisabled: false,
    userRole: ["1", "2"],
  },
];

export default menu;
